import React, { useEffect, useRef } from 'react';
import './EducationModal.scss';
import useAnimatedModalClose from './useAnimatedModalClose';
import useModalFocusTrap from './useModalFocusTrap';
import useModalTouchSwipe from './useModalTouchSwipe';

const FILTER_OPTIONS = [
	{ key: 'age', label: 'AGE', actionProp: 'onAgeClick' },
	{ key: 'pay', label: 'PAY', actionProp: 'onPayClick' },
	{ key: 'time', label: 'TIME', actionProp: 'onTimeClick' },
	{ key: 'focusArea', label: 'FOCUS AREA', actionProp: 'onFocusAreaClick' },
	{ key: 'education', label: 'ACADEMIC LEVEL', actionProp: 'onEducationClick' },
];

function FilterOptionsModal({ onClose, onEducationClick, onAgeClick, onPayClick, onTimeClick, onFocusAreaClick, forceClose }) {
	const modalRef = useRef(null);
	const closeRef = useRef(null);
	const { isClosing, requestClose } = useAnimatedModalClose(onClose);
	const actions = { onEducationClick, onAgeClick, onPayClick, onTimeClick, onFocusAreaClick };
	const { swipeOffset, isSwiping } = useModalTouchSwipe({ modalRef, requestClose });

	useModalFocusTrap({
		modalRef,
		requestClose,
		initialFocusRef: closeRef,
		focusableSelector: 'button',
	});

	useEffect(() => {
		if (forceClose && !isClosing) {
			requestClose();
		}
	}, [forceClose, isClosing, requestClose]);
	const slowSlideClass = isClosing ? ' slow-slide-down' : ' slow-slide-up';
	const swipeStyle = {
		'--swipe-offset': `${swipeOffset}px`,
		'--swipe-opacity': swipeOffset > 0 ? String(Math.max(0.25, 1 - swipeOffset / 420)) : '1',
	};

	const handleSelect = actionProp => {
		actions[actionProp]();
	};

	return (
		<div
			className={`edu-modal-overlay${isClosing ? ' closing' : ''}`}
			role="presentation"
			onClick={event => {
				if (event.target === event.currentTarget) {
					requestClose();
				}
			}}
		>
			<div
				className={`edu-modal${isClosing ? ' closing' : ''}${slowSlideClass}${isSwiping ? ' is-swiping' : ''}`}
				role="dialog"
				aria-modal="true"
				aria-labelledby="filter-options-title"
				ref={modalRef}
				style={swipeStyle}
			>
				<button className="edu-modal-handle-btn" onClick={requestClose} aria-label="Close filter menu" type="button" />
				<div className="edu-modal-header">
					<span className="edu-modal-back-spacer" aria-hidden="true" />
					<h2 id="filter-options-title" className="edu-modal-title">Filter By</h2>
					<button
						className="edu-modal-close"
						onClick={requestClose}
						aria-label="Close filter menu"
						ref={closeRef}
						type="button"
					>
						<span aria-hidden="true">&#10005;</span>
					</button>
				</div>

				<div className="edu-modal-nav-list" role="list">
					{FILTER_OPTIONS.map(option => (
						<button
							key={option.key}
							className="edu-modal-nav-option"
							type="button"
							onClick={() => handleSelect(option.actionProp)}
						>
							<span className="edu-modal-nav-label">{option.label}</span>
							<span className="edu-modal-nav-chevron" aria-hidden="true">&gt;</span>
						</button>
					))}
				</div>
			</div>
		</div>
	);
}

export default FilterOptionsModal;